import knitStitch from "../images/knitstitch.png";
import purlStitch from "../images/purlstitch.png";
import {Round} from "./Parsing";
import {EventService} from "../services/eventService";
import {useState} from "react";

type Props = {
    round: Round;
    hoverActive: boolean;
    index: number;
    onMouseEnter: (id: number) => void;
    gauge: number[];
    userId: string;
    taskId: string;
}

export default function RoundVisual(props: Props) {
    const eventService = new EventService();
    const [mouseTime, setMouseTime] = useState<null | Date>(null);

    const handleMouseEnter = () => {
        if (props.hoverActive) {
            props.onMouseEnter(props.round.properties.line);

            setMouseTime(new Date());
        }
    }

    const handleMouseLeave = () => {
        if (props.hoverActive && mouseTime) {
            const date = new Date();
            const timeElapsed = date.getTime() - mouseTime.getTime();
            if (timeElapsed > 500) {
                const date = new Date();
                eventService.saveEvent(props.userId, props.taskId, {
                    id: date.valueOf(),
                    type: "SELECT_INSPECTOR",
                    time: date.toString(),
                    value: {
                        round: props.round,
                        visualRowInspected: props.index,
                        hoverTime: timeElapsed,
                        startTime: mouseTime.getTime(),
                        endTime: date.getTime()
                    }
                });
            } else {
                setMouseTime(null);
            }
        }
    }

    let height = 18;
    let width = 18;
    if (props.gauge.length === 2) {
        if (props.gauge[0] < 10) {
            width = 10;
        } else if(props.gauge[0] > 30) {
            width = 30;
        } else {
            width = props.gauge[0];
        }

        if (props.gauge[1] < 10) {
            height = 10;
        } else if(props.gauge[1] > 30) {
            height = 30;
        } else {
            height = props.gauge[1];
        }

        height = Math.round((22/height)*15);
        width = Math.round((22/width)*15);
    }

    return (
        <div
            onMouseEnter={() => handleMouseEnter()}
            onMouseLeave={() => handleMouseLeave()}
            className={`round  ${props.hoverActive ? "row-hover" : ""}`}
            style={{height: `${height}px`}}>
        {props.round.stitches.map((stitch: any, index) => {
            if (stitch === "k") {
                return (
                    <div className={"stitch " + (props.round.properties.err ? "stitch-err" : "")} key={`stitch-${index}`}>
                        <img className={"st-hover " + (props.round.properties.err ? "st-err" : "")} alt="" src={knitStitch} height={height} width={width}/>
                    </div>
                );
            } else if (stitch === "p") {
                return (
                    <div className={"stitch " + (props.round.properties.err ? "stitch-err" : "")} key={`stitch-${index}`}>
                        <img className={"st-hover " + (props.round.properties.err ? "st-err" : "")} alt="" src={purlStitch} height={height} width={width}/>
                    </div>
                );
            }
        })}
    </div>);
}